import React from 'react';
import Banner from '../components/Banner';
import WelcomeSection from '../components/WelcomeSection';
import FacilitiesSection from '../components/FacilitiesSection';
import AdmissionSection from '../components/AdmisionSection';
import ProgramsSection from '../components/ProgramsSection';
import AchievementsSection from '../components/AchievementsSection';
import Contact from '../components/Contact';

const HomePage = () => {
  return (
    <>
      <Banner />
      <WelcomeSection />
      <FacilitiesSection />
      <AdmissionSection />
      <ProgramsSection/>
      <Contact />
      <AchievementsSection />
    </>
  );
};

export default HomePage;